import { useState, useEffect } from 'react'

import Comment from './components/Comment'
import CommentForm from './components/CommentForm'
import {
  LoginModalConsumer,
  LoginModalProvider,
} from '../Login/context/LoginModalContext'

export function Comments() {
  const [comments, setComments] = useState([])
  const [isLoading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    App.Request.get('/comments.json', {
      params: {
        commentable_type: App.State.commentableType,
        commentable_id: App.State.commentableId,
      },
    }).then(({ data }) => {
      setComments(data)
      setLoading(false)
    })
  }, [])

  const handleNewComment = (comment) => {
    setComments([comment, ...comments])
  }

  return (
    <LoginModalProvider>
      <LoginModalConsumer>
        {({ openLoginModal }) => (
          <div className="anchor">
            <CommentForm
              commentCreated={handleNewComment}
              placeholder={I18n.t('posts.comment_placeholder')}
            />

            {isLoading && (
              <div className="d-flex justify-content-center">
                <div className="spinner-border" role="status" />
                <span className="h4 ps-2">{I18n.t('loading')}</span>
              </div>
            )}

            {!isLoading && comments.length === 0 && (
              <div className="d-flex justify-content-center">
                <span className="h4 ps-2 text-muted">
                  {I18n.t('posts.no_comments')}
                </span>
              </div>
            )}

            {!isLoading &&
              comments.map((comment) => (
                <Comment
                  openLoginModal={openLoginModal}
                  comment={comment}
                  key={`comment-${comment.id}`}
                />
              ))}
          </div>
        )}
      </LoginModalConsumer>
    </LoginModalProvider>
  )
}
